import React from 'react';
import { Box } from '@mui/material';

type Props = {
  className?: string;
  [key: string]: any;
};

function FullLogo({ className = '', ...other }: Props) {
  return (
    <Box
      alt="logo"
      {...other}
      component="img"
      className={className}
      src="/static/brand/full-logo.png"
    />
  );
}

export default FullLogo;
